import React, { useEffect, useState } from 'react';
import { IFileContent } from '@/util/Request/requestType';
import { DeleteOutlined } from '@ant-design/icons';
import {Button} from 'antd';
import { updateSuccessMessage, updateWarningMessage } from '@/redux/reducer/common';
import {updateFileContent} from '@/redux/reducer/agrialertTemplate';
import { useDispatch, useSelector } from 'react-redux';
import './index.less';
import {
    uploadReportBanner
} from '@/util/Request/agrialert';
import IF from '@/components/IF';

interface IProp{
    uploadSuccessCallback?: () => void
    saveFlag?: boolean
    getLateSelectedBanner?: () => void
    isDisabled:boolean
}

const UploadBanner = (prop:IProp) => {
    const {
        uploadSuccessCallback,
        isDisabled
    } = prop;
    const dispatch = useDispatch();
    const filetypes = ['.JPG', '.PNG', '.GIF', '.BMP', '.JPEG', '.TIFF', '.PSD', '.SVG', '.DOC', '.DOCX', '.PPT', '.PPTX', '.XLS', '.XLSX', '.PDF'];
    //upload img
    const fileUploadLimit = 5 * 1024 * 1024; // 1MB in bytes. Formula: 1MB = 1 * 1024 * 1024.
    const [imageCollection, setImageCollection] = React.useState([] as any[]);
    const [fileContent, setFileContent] = React.useState([] as IFileContent[]);
    const renderImage = (imageObj, files) => {
        const newImageCollection = [...imageCollection];
        //Judge whether it is duplicate attachment
        const tmp = newImageCollection.filter(x => x.props.children[1].key == imageObj.fileName);
        if (tmp.length > 0) {
            return;
        }
        newImageCollection.push(
            <div key={imageObj.timestamp} style={{display:'flex',flexDirection:'row',alignItems:'center',border:'1px solid #ddd',height:'36px'}}>
                <img src={imageObj.preview} alt={imageObj.fileName} style={{ width: '40px', height: '34px' }} />
                <span className='banner-title' key={imageObj.fileName} >{imageObj.fileName}</span>
                <span style={{cursor:'pointer',padding:'0 10px'}} onClick={e => setDeleteItem(imageObj.timestamp)} ><DeleteOutlined /></span>
            </div>);
        const tmpFileObject: IFileContent = {
            fileKey: imageObj.timestamp,
            fileContent: files
        };
        const tmpFile = [...fileContent];
        tmpFile.push(tmpFileObject);
        setFileContent([...tmpFile]);
        dispatch(updateFileContent([...tmpFile]));

        setImageCollection([...newImageCollection]);
    };
    //Add Image
    const addImage = (imageObj) => {
        const newImageCollection = [...imageCollection];
        //get upload file Suffix
        const uploadFileName = (imageObj.fileName.substring(imageObj.fileName.lastIndexOf('.'))).toUpperCase();
        //Judge whether it is an allowed file type
        if (!filetypes.includes(uploadFileName)) {
            alert('Allowed file types: Image(JPG/JPEG/PNG/GIF/SVG/BMP/TIFF/PSD)');
            setImageCollection([...imageCollection.filter(x => x.key != imageObj.timestamp)]);
            setFileContent([...fileContent.filter(x => x.fileKey != imageObj.timestamp)]);
            dispatch(updateFileContent([...fileContent.filter(x => x.fileKey != imageObj.timestamp)]));
            return;
        }
        ////Judge whether it is duplicate attachment
        const tmp = newImageCollection.filter(x => x.props.children[1].key == imageObj.fileName);
        console.log('tmp.length',tmp);
        if (tmp.length > 0) {
            alert('Do not add duplicate attachments');
            return;
        }
        return true;
    };
    //Delete file
    const [deleteItem, setDeleteItem] = useState('');
    useEffect(() => {
        //remove image from page
        setImageCollection([...imageCollection.filter(x => x.key != deleteItem)]);
        //remove from fileContent
        setFileContent([...fileContent.filter(x => x.fileKey != deleteItem)]);
        dispatch(updateFileContent([...fileContent.filter(x => x.fileKey != deleteItem)]));
    }, [deleteItem]);
    //Change file
    const changeUrl = async (e: any) => {
        const file = e.target.files[0];
        console.log('filefile', e);
        const files = e.target.files;
        if (file != undefined) {
            // Create an object containing image information.
            const imageObj = {
                fileName: file.name,
                fileSize: file.size,
                fileType: file.type,
                timestamp: Date.now(),
                preview: URL.createObjectURL(file),
            };
            //render to page
            renderImage(imageObj, files);
            // Add To Local storage
            addImage(imageObj);
        }
    };

    // useEffect(()=>{

    // },[saveFlag]);

    const uploadBanner = async()=>{
        console.log('666fileContent:',fileContent);
        if(fileContent?.length>0){
            const res =await uploadReportBanner(fileContent);
            if(res.message==='Success'){
                setImageCollection([]);
                setFileContent([]);
                dispatch(updateFileContent([]));
                dispatch(updateSuccessMessage('Uploaded successfully'));
                uploadSuccessCallback();

                // get all image from s3

            }
        }else{
            dispatch(updateWarningMessage('Please select at least one banner from your local area!'));
        }
    };
    return (
        <div className='upload-banner'>
            <div className="select-banner-div">
                <p>Upload Banner<span className='red'>(Please click the &apos;Upload Banner&apos; button on the right)</span></p>
                <div id="image-collection"
                    className='image-collection-style' style={{marginTop:'8px'}}>
                    {imageCollection}
                </div>
            </div>
            <div className='banner-div'>
                <IF show={isDisabled}>
                    <label htmlFor='image-upload'
                        className='label-style'
                        style={{pointerEvents: 'none',opacity: '0.5'}}>
                        Upload Banner</label>
                </IF>
                <IF show={!isDisabled}>
                    <label htmlFor='image-upload'
                        className='label-style'>Upload Banner</label>
                </IF>
                <input type="file"
                    style={{display:'none'}}
                    id='image-upload'
                    accept=".JPG,.JPEG,.PNG,.GIF,.SVG,.BMP,.TIFF,.PSD"
                    onChange={changeUrl} />
            </div>
        </div>
    );
};

export default UploadBanner;